import apiClient from '../../../shared/lib/api'
import type { Product } from '../types'
import { getSelectedTenantId } from '../lib/tenant-selection'

interface ProductSearchResponse {
  products?: Product[]
}

interface ProductSearchParams {
  q: string
  tenantId?: string
  limit?: number
}

export async function searchProducts({
  q,
  tenantId,
  limit = 20,
}: ProductSearchParams): Promise<Product[]> {
  const query = q.trim()
  if (!query) return []

  const resolvedTenantId = tenantId || getSelectedTenantId()
  if (!resolvedTenantId) return []

  const response = await apiClient.get<ProductSearchResponse | { data?: ProductSearchResponse }>(
    '/v1/products/search',
    {
      params: {
        q: query,
        tenant_id: resolvedTenantId,
        limit,
      },
    },
  )

  const body = response.data
  const payload = (body && typeof body === 'object' && 'data' in body ? body.data : body) as ProductSearchResponse
  return Array.isArray(payload?.products) ? payload.products : []
}
